import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const AvailabilityHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 1.25rem;
`

export const AvailabilitySubline = styled.p`
  font-size: ${tokens.font.body};
  color: ${tokens.text.muted};
`

export const ControlsRow = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
`

export const Caption = styled.p`
  margin-top: 1rem;
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
  line-height: 1.5;
`

export const KpiRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: ${tokens.space.sm};
  margin: 1.5rem 0;

  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`

export const CampSummaryRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`

export const CampSummaryChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.375rem 0.75rem;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  font-size: ${tokens.font.label};
  color: ${tokens.text.secondary};
`

export const CampSummaryCount = styled.span`
  font-weight: 700;
  color: ${tokens.status.success.fg};
  font-variant-numeric: tabular-nums;
`

export const ResultStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const CampGroupTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const CampGroupName = styled.span`
  font-size: ${tokens.font.h2};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const RoomGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-child {
    border-bottom: none;
  }
`

export const RoomGroupHead = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const RoomGroupName = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.secondary};
`

export const RoomGroupContext = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const BedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(15rem, 1fr));
  gap: 0.625rem;
`

export const BedCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.75rem 0.875rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
`

export const BedCardTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
`

export const BedCardLabel = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.accent.base};
`

export const BedCardLocation = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};

  svg {
    width: 0.85rem;
    height: 0.85rem;
    flex: none;
  }
`

export const PolicyPills = styled.div`
  display: flex;
  gap: 0.375rem;
`

export const BedCardActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 0.25rem;
`

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2.5rem 0;
  font-size: ${tokens.font.body};
  color: ${tokens.text.muted};
  text-align: center;
`

export const LoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
`
